import { render, staticRenderFns } from "./logisticsInfo.vue?vue&type=template&id=1abbc2ed&scoped=true&"
import script from "./logisticsInfo.vue?vue&type=script&lang=ts&"
export * from "./logisticsInfo.vue?vue&type=script&lang=ts&"
import style0 from "./logisticsInfo.vue?vue&type=style&index=0&id=1abbc2ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abbc2ed",
  null
  
)

export default component.exports